import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridDetailRow } from "@progress/kendo-react-grid";
import React from "react";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import WorkStreamWithRoles from "../Dashboard/WorkStreamWithRoles";

export default class ManageUserControl extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      selectedOrgUnit: [],
      ownerList: [],
      orgunitIds: [],
      OrgUnitIds: [],
      roleArrayRisk:[],
      roleArrayTask:[]
    };
  }
  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = () => {
    // if (!secureLocalStorage.getItem("loginUserId")) {
    //   let token =
    //     secureLocalStorage.getItem("loggedClient") === "user"
    //       ? secureLocalStorage.getItem("userKey")
    //       : secureLocalStorage.getItem("tenantKey");
    //   let loggedClient = secureLocalStorage.getItem("loggedClient");
    //   this.props.history.push({
    //     pathname: `/${loggedClient}/${token}/unauthorized`,
    //   });
    // } else {
      this.getOrganizationsUnits();
      this.getUsersWithoutPMO();
    // }
  };

  populate = (user) => {
    console.log("user", user);

    let ids = [];
    for (var i = 0; i < user.workstreamRoles.length; i++) {
      ids.push(user.workstreamRoles[i].workstreamId);
    }
    this.setState({
      OrgUnitIds: ids, //user.workStreamIds,
      selectedOrgUnit: ids,
      // orgunitIds: ids,
      workstreamRoles: user.workstreamRoles,
    });
    this.refs.child.refreshRole(user.workstreamRoles);
    setTimeout(() => {
      this.refs.child.refreshData(ids);
      this.refs.child.refreshRole(user.workstreamRoles);
    }, 1000);
    
  };

  getUsersWithoutPMO = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      let response = await Api.GetUsersWithoutPMO(request);
      if (response.status === 200 && response.tenantUsers) {
        var tempUserList = [];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
            workStreamIds: response.tenantUsers[i].workStreamIds,
            workstreamRoles: response.tenantUsers[i].workstreamRoles,
          });
        }
        var data = this.props.dataItem;
        var setUserObj = {
          text: data.name,
          value: data.userId,
          workStreamIds: data.workStreamIds,
          workstreamRoles: data.workstreamRoles,
        };
        this.setState({
          ...this.state,
          ownerList: tempUserList,
          loader: false,
          user: setUserObj,
        });

        await this.populate(setUserObj);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      toastr.error("Failed");
      console.error(error);
    }
  };
  getOrganizationsUnits = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
        IsTasksModule:true
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getOrgUnits(request, "PMO");
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        this.setState({
          ...this.state,
          workstreamData: response.organisationUnit,
        });
      } else {
        this.setState({ ...this.state, loader: false });
        this.setState({ ...this.state, workstreamData: [] });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getRiskList = async (orgUnitListIds) => {
    if (orgUnitListIds && orgUnitListIds.length > 0) {
      this.setState({
        ...this.state,
        OrgUnitIds: orgUnitListIds,
      });
    }
  };
  setEmptyRiskList = async (ids) => {
    this.setState({
      ...this.state,
      OrgUnitIds: [],
    });
  };
  assignWorkstreamToUser = async () => {
    try {
      let orgunitIds=this.constructWorkstreamRoleJson(this.state.roleArrayRisk,this.state.roleArrayTask);
      // let roleFlag=this.areAllKeysFilled(orgunitIds);
      // if (!roleFlag) {
      //   toastr.error("Please select role for all the workstreams");
      //   return;
      // }
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient === "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
        UserId: this.state.user.value,
        Name: this.state.user.text,
        workStreamIds: this.state.OrgUnitIds,
        orgunitIds: orgunitIds,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.PmoUserUpdate(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.props.openWorkstreamPopupClose();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  constructWorkstreamRoleJson = (arr1, arr2) => {
    const merged = arr1.map(item1 => {
        const match = arr2.find(item2 => item2.id === item1.id);
        return match ? { id: item1.id, role: item1.role, taskRole: match.taskRole } : item1;
    });

    // Add items from arr2 that are not in arr1
    const unmatched = arr2
        .filter(item2 => !arr1.some(item1 => item1.id === item2.id))
        .map(item2 => ({ id: item2.id, taskRole: item2.taskRole })); // Ensuring format consistency

    return [...merged, ...unmatched];
};
  areAllKeysFilled = (array) => {
    const requiredKeys = ['id', 'taskRole', 'role'];
    return array.every(obj =>
      requiredKeys.every(key => obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null && obj[key] !== '')
    );
  };
  selectUser = (e) => {
    this.setState({
      user: e.target.value,
    });
  };
  saveRoleWithOrgId = (data) => {
    this.setState({ ...this.state, orgunitIds: data }); //workstreamId with role
    this.state = { ...this.state, orgunitIds: data };
  };

  saveRoleWithOrgIdForRisk = (data) => {
    this.setState({ ...this.state, roleArrayRisk: data }, () => {
      console.log("roleArrayRisk", this.state.roleArrayRisk); 
    });
  };
 
  saveRoleWithOrgIdForTask = (data) => {
    this.setState({ ...this.state, roleArrayTask: data }, () => {
      console.log("roleArrayTask", this.state.roleArrayTask); 
    });
  };

  render() {
    return (
      <div className="appCont" style={{ width: "975px" }}>
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="mainWrapper">
          <div className="rm-tanent-cont">
            <div className="rm-form-cont relPosition userAssign">
              <h6>Manage User</h6>

              <form name="form">
                <div className="rm-form ">
                  <div className="rm-field-container rm-service-plan">
                    <label>Selected User</label>
                    <DropDownList
                      style={{ width: "100%" }}
                      onChange={(e) => this.selectUser(e)}
                      value={this.state.user}
                      data={this.state.ownerList}
                      valueField="value"
                      textField="text"
                      disabled={true}
                    />
                    <div className="errorMsg"></div>
                  </div>

                  <div className="rm-field-container rm-service-plan">
                    <label>Select Workstream</label>
                    <div className="selectWorkStream">
                    <WorkStreamWithRoles
                      {...this.props}
                      selectedOrgUnit={this.state.selectedOrgUnit}
                      orgUnitData={this.state.workstreamData}
                      getRiskList={this.getRiskList}
                      getEmptyRiskList={this.setEmptyRiskList}
                      orgunitIds={this.saveRoleWithOrgId}
                      saveRoleWithOrgIdForRisk={this.saveRoleWithOrgIdForRisk}
                      saveRoleWithOrgIdForTask={this.saveRoleWithOrgIdForTask}
                      editModeWorkstreamRoles={this.state.workstreamRoles}
                      isTenent={false}
                      ref="child"
                    />
                    </div>
                  </div>
                </div>
                <div className="btn-group">
                  <button
                    type="button"
                    onClick={this.assignWorkstreamToUser}
                    className="rm-btn-primary"
                  >
                    Assign
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    onClick={() => this.props.openWorkstreamPopupClose()}
                    className="rm-btn-primary cancelImpacts"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
